module.exports = __webpack_public_path__ + "static/img/in-turn-rotation.f7a856f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/in-turn-rotation.gif
// module id = b1lE
// module chunks = 14